/*
* ファイルアップロードでファイル名が表示される
* 1MB以上のサイズのファイルはリサイズされる
*/
export default class FileUpload {
  constructor() {
    this.$targets = document.querySelectorAll('[data-target="jsFileUpload"]');
    this.$fileName = document.querySelectorAll('[data-target="jsFileName"]');
    this.$submitButton = document.querySelector('[data-target="submitButton"]');
    this.MAX_IMAGE_SIZE = 1048576;
  }

  attachEvent() {
    Array.prototype.forEach.call(this.$targets, (item, index) => {
      item.addEventListener('change', () => {

        if (item.files[0]) {
          let fileList = '';
          for (let i = 0; i < item.files.length; i++){
            fileList += `<span>添付ファイル：${item.files[i].name}</span>`;
          }
          this.$fileName[index].innerHTML = fileList;

        } else {
          this.$fileName[index].innerHTML = '選択されていません';
        }
      });
    });

    if(this.$submitButton) {
      this.$submitButton.addEventListener('click', async () => {
        if (!confirm('基本情報を変更してよろしいですか？（審査と本人確認が完了するまで、プロジェクトへ応募できなくなります）')) {
          return;
        }

        const basicInfoForm = document.querySelector('[data-target="basicInfoForm"]');
        const formData = new FormData(basicInfoForm);

        // 画像圧縮処理
        for (const data of [...formData]) {
          const condition = data[1].type && data[1].type.indexOf('image') !== -1 && data[1].size >= this.MAX_IMAGE_SIZE;

          if (condition) {
            const compressedImage = await this._imageResize(data[1]);
            formData.set(data[0], compressedImage, data[1].name);
          } else {
            formData.set(data[0], data[1]);
          }
        }

        basicInfoForm.addEventListener('formdata', e => {
          for(const [key, value] of formData.entries()) {
            e.formData.set(key, value);
          }
        });

        basicInfoForm.submit();
      });
    }
  }

  _imageResize(imgFile) {
    return new Promise((resolve) => {
      const MAX_IMAGE_WIDTH = 800;
      const reader = new FileReader();
      const image = new Image();

      reader.onload = (e) => {
        image.onload = () => {
          // リサイズベースで容量を圧縮
          const ratio = MAX_IMAGE_WIDTH / Math.max(image.width, image.height);
          const width = image.width * ratio;
          const height = image.height * ratio;

          const canvas = document.createElement('canvas');
          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext('2d');
          ctx.clearRect(0, 0, width, height);
          ctx.drawImage(image,
            0, 0, image.width, image.height,
            0, 0, width, height
          );

          const  base64 = canvas.toDataURL('image/jpg'); // Data URLからBase64のデータ部分のみを取得
          let blob = this._createBlob(base64);

          if (blob['size'] > this.MAX_IMAGE_SIZE) {
            // 1MB以内に容量を圧縮
            const capacityRatio = this.MAX_IMAGE_SIZE / blob['size'];
            const processingBinary = canvas.toDataURL('image/jpeg', capacityRatio); //画質落としてバイナリ化
            blob = this._createBlob(processingBinary);
          }

          resolve(blob);
        };
        image.src = e.target.result;
      };

      reader.readAsDataURL(imgFile);
    });
  }

  _createBlob(base64) {
    const base64Data = base64.split(',')[1];
    const data = window.atob(base64Data);
    const buff = new ArrayBuffer(data.length);
    const arr = new Uint8Array(buff);

    for( let i = 0; i < data.length; i++){
      arr[i] = data.charCodeAt(i);
    }

    return new Blob([arr], {type: 'image/jpeg'});
  }

}
